/**
 * timeZone.js — Fuseau horaire du navigateur (D248).
 *
 * Le navigateur détecte le fuseau et l'envoie au serveur (inscription, import
 * CSV, météo) ; le serveur le valide (shared/timeZone.js) et retombe sur son
 * fuseau par défaut s'il est invalide. Aucune valeur de fuseau en dur ici.
 */

/** Fuseau IANA du navigateur, ou chaîne vide si le moteur ne le donne pas. */
export function browserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch (err) {
    if (err instanceof RangeError) return '';
    throw err;
  }
}

/** Fuseaux IANA connus du moteur, triés ; vide si la liste n'existe pas. */
export function listTimeZones() {
  return typeof Intl.supportedValuesOf === 'function'
    ? Intl.supportedValuesOf('timeZone')
    : [];
}
